export default __webpack_public_path__ + "994808e6f12f2c0b50e20fd7e9283347.png";